var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 492.8,
    height: 492.8,
    viewBox: "0 0 492.8 492.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-103.6 -33.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M350,33.6c-135.92,0-246.4,110.43-246.4,246.4,0,135.92,110.48,246.4,246.4,246.4,135.97,0,246.4-110.48,246.4-246.4,0-135.97-110.43-246.4-246.4-246.4ZM350,56A224,224,0,1,1,126,280,223.8,223.8,0,0,1,350,56Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M264.68,184.75A11.2,11.2,0,0,0,258.032,204l75.949,76.125-75.949,75.949A11.261,11.261,0,0,0,273.958,372l76.125-76.125L426.032,372a11.261,11.261,0,0,0,15.926-15.926l-76.125-75.949L441.957,204a11.26,11.26,0,1,0-15.926-15.922l-75.949,75.949-76.125-75.949a11.194,11.194,0,0,0-8.051-3.328c-.41-.02-.816-.02-1.227,0Z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e26f0bc9c109ccc9a8d6627784d1fcab.svg";
export { ForwardRef as ReactComponent };